import React from 'react';
export function Footer() {
  return <footer className="w-full bg-white px-4 py-8 text-gray-900 text-base leading-6 border-t border-cyan-brand/20" style={{
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-148">
      <div className="mx-auto max-w-3xl text-center" data-id="element-149">
        {/* Logo */}
        <div className="mb-3 text-xl font-black tracking-[2.4px] text-cyan-brand" data-id="element-150">
          👶 CONSTRUYE PROGRESO™
        </div>

        {/* Tagline */}
        <p className="mx-auto max-w-[576px] text-xs leading-[20px] text-gray-600 m-0 mb-3" data-id="element-151">
          El sistema de estimulación temprana N°1 para profesionales en
          Argentina.
        </p>

        <p className="text-xs italic text-gray-500 m-0 mb-5" data-id="element-152">
          Porque estimular el desarrollo de un niño no debería costarte todas
          las noches de la semana.
        </p>

        {/* Contact Info */}
        <div className="mb-5 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-xs text-gray-600" data-id="element-153">
          <span data-id="element-154">📧 construyeprogresoo@gmail.com</span>
          <span className="hidden sm:block text-gray-300" data-id="element-155">•</span>
          <span data-id="element-156">📲 @construyeprogresoo</span>
          <span className="hidden sm:block text-gray-300" data-id="element-157">•</span>
          <span data-id="element-158">🌐 www.construyeprogreso.com</span>
        </div>

        {/* Divider */}
        <div className="mb-5 h-px bg-cyan-brand/20" data-id="element-159" />

        {/* Copyright */}
        <p className="text-[10px] text-gray-500 m-0 mb-1" data-id="element-160">
          © Construye Progreso™ 2025 — Todos los derechos reservados.
        </p>
        <p className="text-[10px] text-gray-400 m-0 mb-4" data-id="element-161">
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}